import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Dispatch } from 'redux';
import { CSVLink } from 'react-csv';

import { getUsers } from '../../../repositories/UserRepository';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { getSorting, getFilters, getSearch } from '../../../stores/tables/selectors';
import { Data } from 'react-csv/components/CommonPropTypes';
import { TableFilters, TableSorting } from '../../../stores/tables/state';
import { getApplications } from '../../../repositories/ApplicationRepository';
import { getWorkspaceName } from '../../../stores/workspaces/selectors';

interface Props extends LocalizeContextProps {
  hasPrivilege: (privileges: string[]) => boolean;
  getWorkspaceName: (id: string) => string;
    sorting: TableSorting;
    filters: TableFilters;
    search: string;
}
interface State {
    csvData: Data;
}

const initialState: State = {
    csvData: []
};

class ExportReportAction extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = initialState;
  }

  public render() {
    const t = this.props.translate;
    if (this.props.hasPrivilege(['WORKSPACE_ADMIN', 'SUPER_ADMIN'])) {
      return (
        <React.Fragment>
          <CSVLink
            data={this.state.csvData}
            filename='applications.csv'
            className='hidden'
            target='_blank'
            ref={(r: any) => (this.csvLink = r)}
            separator=';'
          />
          <Button onClick={this.writeCSVReport} className='mr-2'>
            <FontAwesomeIcon icon={['fal', 'th-list']} className='mr-4' />
            {t('applications.button.applicationReport')}
          </Button>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }

  private writeCSVReport = () => {
    getApplications(
      999999,
      0,
      {
        column: this.props.sorting?.column ?? 'title',
        order: this.props.sorting?.order ?? 'asc',
      },
      {
        u: this.props.filters?.u,
        w: this.props.filters?.w,
        s: this.props.filters?.s,
      },
      this.props.search
    ).then(applications => {
      let csvList = [
        [
          "Title",
          "Location",
          "Server",
          "Workspace"
        ]
      ];
      applications.items.forEach(application => {
        csvList.push([
          application.title,
          application.location_path,
          application.server.hostname,
          this.getWorkspaceName(application.workspace?.id)
        ]);
      });
      this.setState({ csvData: csvList }, () => {
        this.csvLink.link.click();
      });
    });
  };
  private csvLink: any;

  private getWorkspaceName = (workspaceId?: string) => {
    if (workspaceId === undefined) {
      return '';
    } else {
      return this.props.getWorkspaceName(workspaceId);
    }
  }
}


const mapStateToProps = (state: RootState) => {
    return {
        hasPrivilege: hasPrivilege(state),
        getWorkspaceName: getWorkspaceName(state),
        sorting: getSorting(state, 'applications'),
        filters: getFilters(state, 'applications'),
        search: getSearch(state, 'applications'),
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(ExportReportAction));